import { db } from '@/firebase/init';
import { Product } from '@/types/services';
import { Price } from '@/types/Stripe';
import { collection, documentId, getDocs, query, where } from 'firebase/firestore';

export async function fetchActiveProductsWithPrices(): Promise<Product[]> {
  const productsRef = collection(db, 'products');
  const activeProductsQuery = query(
    productsRef,
    where('active', '==', true),
    where(documentId(), 'in', import.meta.env._VITE_ALLOWED_SUBSCRIPTIONS.split(',')),
  );

  const productsSnapshot = await getDocs(activeProductsQuery);

  const products: Product[] = [];

  for (const productDoc of productsSnapshot.docs) {
    const productData = productDoc.data() as Product;
    const pricesRef = collection(db, `products/${productDoc.id}/prices`);
    const pricesSnapshot = await getDocs(pricesRef);

    const activePrices: Price[] = pricesSnapshot.docs
      .map((doc) => ({ id: doc.id, ...doc.data() } as Price))
      .filter((price) => price.active);

    products.push({
      ...productData,
      prices: activePrices,
      id: productDoc.id,
    });
  }

  const sortedProducts = products.sort((a, b) => {
    const aPrice = a.prices[0]?.unit_amount || 0;
    const bPrice = b.prices[0]?.unit_amount || 0;
    return aPrice - bPrice;
  });

  return sortedProducts;
}
